export { default } from './SectionDevisionCards';